import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className={`inline-block bg-gold text-carbon font-bold text-lg md:text-xl px-8 py-4 rounded-md shadow-gold-glow hover:shadow-gold-glow-hover transition-shadow duration-300 text-center ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} data-id="element-45">
      {children}
    </motion.a>;
}